import { combineReducers } from "redux"
import customizer from "./customizer/"
import login from "./auth/loginReducer"
import navbar from "./navbar/Index"
import Tips from "./tips/tipsReducer"
import Chat from "./chats/chatsReducer"
import notification from "./notification/notificationReducer"
//import User from './user/';

const rootReducer = combineReducers({
  customizer: customizer,
  login:login,
  navbar: navbar,
  Tip:Tips,
  Chat:Chat,
  notification:notification
  //user:User
})

export default rootReducer
